"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPkPassOfTicket = exports.getPdfTicketsOfOrder = exports.getReceiptOfOrder = void 0;
const axios_instance_1 = require("./../axios-instance");
function getReceiptOfOrder(orderId, organizerId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield axios_instance_1.api
            .get(`Order/${orderId}/Receipt?organizerId=${organizerId}`, {
            responseType: "blob",
        })
            .then((res) => {
            const data = window.URL.createObjectURL(res.data);
            var link = document.createElement("a");
            link.href = data;
            link.download = "Receipt.pdf";
            link.click();
        })
            .catch((error) => console.error(error.response.data));
    });
}
exports.getReceiptOfOrder = getReceiptOfOrder;
function getPdfTicketsOfOrder(orderId, organizerId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield axios_instance_1.api
            .get(`Order/${orderId}/TicketsPdf?organizerId=${organizerId}`, {
            responseType: "blob",
        })
            .then((res) => {
            const data = window.URL.createObjectURL(res.data);
            var link = document.createElement("a");
            link.href = data;
            link.download = "Tickets.pdf";
            link.click();
        })
            .catch((error) => console.error(error.response.data));
    });
}
exports.getPdfTicketsOfOrder = getPdfTicketsOfOrder;
function getPkPassOfTicket(ticketId) {
    return __awaiter(this, void 0, void 0, function* () {
        yield axios_instance_1.api
            .get(`Ticket/${ticketId}/PkPass`, {
            responseType: "blob",
        })
            .then((res) => {
            const data = window.URL.createObjectURL(res.data);
            var link = document.createElement("a");
            link.href = data;
            link.download = `Ticket_${ticketId}.pkpass`;
            link.click();
        })
            .catch((error) => console.error(error.response.data));
    });
}
exports.getPkPassOfTicket = getPkPassOfTicket;
